import { combineReducers, configureStore } from '@reduxjs/toolkit';
import reducers from './rootReducer';

const rootReducer = combineReducers(reducers);

export const store = configureStore({ reducer: rootReducer });

export type RootState = ReturnType<typeof rootReducer>;
